import * as React from 'react';
import { useDispatch } from 'react-redux';
import { throttle } from 'throttle-debounce';
import { showStickyButton, hideStickyButton } from '../../actions/stickyButton';
import { TThunkDispatch } from '../../types/redux/thunk';

interface IUseStickyButtonParams {
  mobileHeaderRef: React.RefObject<HTMLDivElement>;
  compilationHeaderRef: React.RefObject<HTMLDivElement>;
}

const OFFSET = 24;
const DELAY = 100;

export const useStickyButton = ({ mobileHeaderRef, compilationHeaderRef }: IUseStickyButtonParams) => {
  const dispatch: TThunkDispatch = useDispatch();

  const isInViewport = React.useMemo(
    () =>
      throttle(DELAY, () => {
        const header = mobileHeaderRef.current || compilationHeaderRef.current;

        if (!header) {
          return;
        }

        const top = header.getBoundingClientRect().top;

        const isShown = top <= OFFSET;

        if (isShown) {
          dispatch(showStickyButton());
        } else {
          dispatch(hideStickyButton());
        }
      }),
    [dispatch, compilationHeaderRef, mobileHeaderRef],
  );

  React.useEffect(() => {
    document.addEventListener('scroll', isInViewport);

    return () => {
      document.removeEventListener('scroll', isInViewport);
    };
  }, [isInViewport]);
};
